export enum PermissionEnum {
  CREATE_BILL = 0,
  DELETE_BILL = 1,
  READ_BILLS = 2,

  CREATE_JOB_OFFER = 3,
  DELETE_JOB_OFFER = 4,
  READ_JOB_OFFER = 5,

  CREATE_SERVICE_ENTERPRISE = 6,
  DELETE_SERVICE_ENTERPRISE = 7,
  READ_SERVICES_ENTERPRISE = 8,

  CREATE_CLIENT = 9,
  DELETE_CLIENT = 10,
  READ_CLIENTS = 11,

  CREATE_ARTICLE = 12,
  DELETE_ARTICLE = 13,
  READ_ARTICLES = 14,

  CREATE_PROJECT = 15,
  DELETE_PROJECT = 16,
  READ_PROJECTS = 17,

  CREATE_EMPLOYEE = 18,
  DELETE_EMPLOYEE = 19,
  READ_EMPLOYEES = 20,

  CREATE_TEAM = 21,
  DELETE_TEAMS = 22,
  READ_TEAMS = 23,

  CREATE_PERMISSION = 24,
  DELETE_PERMISSION = 25,
  READ_PERMISSIONS = 26,

  CREATE_ROLE = 27,
  DELETE_ROLE = 28,
  READ_ROLES = 29,
  ASSIGN_ROLE = 30,

  CREATE_USER_ROLE = 31,
  DELETE_USER_ROLE = 32,
  READ_USER_ROLE = 33,

  CREATE_CATEGORY = 34,
  DELETE_CATEGORY = 35,
  READ_CATEGORIES = 36,

  CREATE_USER = 37,
  DELETE_USER = 38,
  READ_USERS = 39,

  CHANGE_PASSWORD_USER = 40,
  CAN_SHOW_KEYS = 41,
  IS_ADMIN = 42,

  CREATE_PDF_EXCEL_FILES = 43,
  DELETE_PDF_EXCEL_FILES = 44,
  READ_PDF_EXCEL_FILES = 45,

  CREATE_BILLING_MONTHLY_EMPLOYEE = 46,
  DELETE_BILLING_MONTHLY_EMPLOYEE = 47,
  READ_BILLING_MONTHLY_EMPLOYEE = 48,

  CREATE_EVENT_CALENDAR = 49,
  DELETE_EVENT_CALENDAR = 50,
  READ_CALENDAR = 51,

  CREATE_CONTRACT = 52,
  DELETE_CONTRACT = 53,
  READ_CONTRACT = 54,

  CREATE_LANGUAGES = 55,
  DELETE_LANGUAGES = 56,
  READ_LANGUAGES = 57,

  CREATE_STOCK = 58,
  DELETE_STOCK = 59,
  READ_STOCK = 60,

  CREATE_SALARY_INCREASE = 61,
  DELETE_SALARY_INCREASE = 62,
  READ_SALARY_INCREASE = 63,

  SUPERADMIN_CREATE_PROJECTS = 64,
  SUPERADMIN_DELETE_PROJECTS = 65,
  SUPERADMIN_READ_PROJECTS = 66,

  NOTIFICATION_CALENDAR = 67,

  CREATE_PROJECTS_HOSTING = 100,
  DELETE_PROJECTS_HOSTING = 101,
  READ_PROJECTS_HOSTING = 102,

  ASSIGN_GENERAL_ADMIN_ROLE = 103,

  EVENT_CALENDAR_CHANGE_STATE = 104,

  CREATE_EVENT_CALENDAR_FOR_OTHERS = 105,
  CREATE_EVENT_CALENDAR_IMMEDIATELY = 106,

  CREATE_NO_LAB_EVENT = 107,

  DAYS_OFF_SETTINGS = 108,

  VIEW_ALL_CALENDAR_EVENTS = 109,

  CREATE_LICENSE_HISTORY = 110,

  READ_LICENSE_DATA_FOR_ALL_USERS = 111,

  SETTING_LICENSE = 112,

  EXPORT_LICENSE_DATA = 113,

  EDIT_ALREADY_HAPPEN_CALENDAR_EVENTS = 114,

  CALCULATE_EMPLOYEE_VACATION_DAYS = 115,

  CREATE_TRANSLATIONS = 116,

  CREATE_BASE_ROLE_DAY_OFF = 117,

  CREATE_PROJECT_THEME_FILE = 118,

  READ_JOB_OFFER_STEP = 119,
  CREATE_JOB_OFFER_STEP = 120,

  READ_JOB_OFFER_PROCESS = 121,
  CREATE_JOB_OFFER_PROCESS = 122,

  READ_POSTULATIONS = 123,

  READ_THEME = 124,
  CREATE_THEME = 125,

  CREATE_PAYMENT = 126,
  DELETE_PAYMENT = 127,

  READ_ABOUT_US = 128,
  CREATE_ABOUT_US = 129,

  READ_LANDING_PAGE = 130,
  CREATE_LANDING_PAGE = 131,

  READ_HEADER_FOOTER = 132,
  CREATE_HEADER_FOOTER = 133,

  READ_TESTIMONIALS = 134,
  CREATE_TESTIMONIALS = 135,

  READ_CONTACT_US = 136,
  CREATE_CONTACT_US = 137,

  READ_SOCIAL_MEDIA = 138,
  CREATE_SOCIAL_MEDIA = 139,

  READ_WEBSITE_SECTION = 140,
  READ_ENTERPRISE_SECTION = 141,
  READ_ACCOUNTANT_SECTION = 142,
  READ_PEOPLE_SECTION = 143,
  READ_MAIL_TEMPLATES = 144,

  CREATE_TIMESHEET = 145,
  UPDATE_TIMESHEET = 146,
  DELETE_TIMESHEET = 147,
  READ_TIMESHEET = 148,
  APPROVE_TIMESHEET = 149,

  CHANGE_EMPLOYEE_TYPE = 150,

  READ_PRODUCTS = 151,
  CREATE_PRODUCT = 152,
  DELETE_PRODUCT = 153,

  READ_JOB_OFFER_WORKFLOW_TEMPLATE = 154,
  CREATE_JOB_OFFER_WORKFLOW_TEMPLATE = 155,
  DELETE_JOB_OFFER_WORKFLOW_TEMPLATE = 156,
  READ_JOB_OFFER_WORKFLOW_INSTANCE = 157,
  CREATE_JOB_OFFER_WORKFLOW_INSTANCE = 158,
  UPDATE_JOB_OFFER_WORKFLOW_INSTANCE = 159,

  DELETE_POSTULATION = 160,
  UPDATE_JOB_OFFER = 161,

  CREATE_RECEIPT = 162,
  DELETE_RECEIPT = 163,
  READ_RECEIPTS = 164,

  SETUP_PROJECT_DOMAINS = 165,
  READ_INBOX = 166,
  WRITE_INBOX = 167,
  VIEW_ALL_CLIENTS = 168,
  IMPORT_WEBSITE = 169,

  READ_CLIENT_DOCUMENTS = 170,
  CREATE_CLIENT_DOCUMENT = 171,
  DELETE_CLIENT_DOCUMENT = 172,
  // Enforced in code, not just role-provisioning convention: DocumentType mutation endpoints
  // require BOTH this permission AND READ_CLIENT_DOCUMENTS (see backend permissions.enum.ts).
  CONFIGURE_DOCUMENT_TYPES = 173,
  READ_TASKS = 174,
  CREATE_TASKS = 175,
  UPDATE_TASKS = 176,
  DELETE_TASKS = 177,
  MOVE_TASKS = 178,
  ASSIGN_TASKS = 179,
  COMMENT_TASKS = 180,
  CONFIGURE_TASK_BOARD = 181,
  MODERATE_TASK_COMMENTS = 182,
  VIEW_PAYMENT_INFORMATION = 183,
  MANAGE_PAYMENT_INFORMATION = 184,

  // Accounts Payable (Bills to Pay + Suppliers) — mirrors backend permissions.enum.ts (183/184 are Payment Information).
  VIEW_ACCOUNTS_PAYABLE = 188,
  CREATE_ACCOUNTS_PAYABLE = 189,
  EDIT_ACCOUNTS_PAYABLE = 190,
  MARK_ACCOUNTS_PAYABLE_PAID = 191,
  MANAGE_SUPPLIERS = 192,

}
